import { render, staticRenderFns } from "./DownloadUploadMasterTemplate.vue?vue&type=template&id=2fdc352a&scoped=true"
import script from "./DownloadUploadMasterTemplate.vue?vue&type=script&lang=js"
export * from "./DownloadUploadMasterTemplate.vue?vue&type=script&lang=js"
import style0 from "./DownloadUploadMasterTemplate.vue?vue&type=style&index=0&id=2fdc352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc352a",
  null
  
)

export default component.exports